import {queueFailure,AdminQueueFailure} from '../../supabase/functions/_shared/adminQueueFailure'
export async function requireQueueResponse(data:any,error:any,action:string){
 let body=data
 if(error?.context?.clone){try{body=await error.context.clone().json()}catch{/* Transport failures have no reliable body. */}}
 if(error||body?.ok!==true){
  const refusal=queueFailure(body?.error?body:error??new AdminQueueFailure('admin_queue_protocol','response'))
  if(typeof body?.message_he==='string'&&body.message_he.length<=800&&/[א-ת]/.test(body.message_he))refusal.message=body.message_he
  if(body?.correlation_id)refusal.message+=' · קבלה: '+String(body.correlation_id)
  throw refusal
 }
 if(action==='admin_queue_action'&&body.result?.ok!==true)throw queueFailure(body.result??new AdminQueueFailure('admin_queue_protocol','response'))
 return body
}
